import styled from 'styled-components';
import { StyledMenuButtonContentFooterProps } from './types';
import { baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledMenuButtonContentFooter = styled.div<StyledMenuButtonContentFooterProps>`
  ${baseContainer}
`;
